import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlaceholder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPlaceholder"><Path d="M3.75 13.75V10.25M10.25 3.75H13.75M20.25 10.25V13.75M13.75 20.25H10.25M6.25 20.25C4.86929 20.25 3.75 19.1307 3.75 17.75M20.25 17.75C20.25 19.1307 19.1307 20.25 17.75 20.25M17.75 3.75C19.1307 3.75 20.25 4.86929 20.25 6.25M3.75 6.25C3.75 4.86929 4.86929 3.75 6.25 3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPlaceholder;
